const basicSurvey = {
    survey_config: {
        delimiter: '',
        status: 'delivered',
        flow: 'internal'
    }
}

export default basicSurvey;
